import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, FileText, ShieldCheck } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function VerifyDVRPage() {
  const { id } = useParams();
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    axios.get(`${BACKEND}/api/dvr/verify/${id}`)
      .then((r) => setState({ loading: false, error: null, data: r.data }))
      .catch((err) => setState({ loading: false, error: err.response?.data?.detail || "DVR non trovato", data: null }));
  }, [id]);

  return (
    <div className="min-h-screen flex items-start justify-center bg-gradient-to-br from-slate-50 to-white dark:from-slate-950 dark:to-black p-6">
      <div className="max-w-2xl w-full mt-12 space-y-6">
        <div className="flex items-center gap-3">
          <ShieldCheck className="w-8 h-8 text-primary" />
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Verifica autenticità DVR</h1>
            <p className="text-sm text-muted-foreground">Sicurgarda Scadenze — D.Lgs. 81/08</p>
          </div>
        </div>
        <div className="bg-card border border-border rounded-lg p-6" data-testid="verify-dvr-result">
          {state.loading && <div className="text-muted-foreground">Verifica in corso…</div>}
          {state.error && (
            <div className="flex items-start gap-3 text-rose-700">
              <XCircle className="w-6 h-6 shrink-0 mt-0.5" />
              <div>
                <div className="font-semibold">DVR non valido</div>
                <div className="text-sm text-muted-foreground">{state.error}</div>
              </div>
            </div>
          )}
          {state.data && (
            <div className="space-y-4">
              <div className="flex items-center gap-2 text-emerald-700">
                <CheckCircle2 className="w-6 h-6" />
                <span className="font-semibold">DVR autentico</span>
              </div>
              <div className="grid gap-1.5 text-sm">
                <Row k="Documento" v={state.data.title} />
                <Row k="Cliente" v={state.data.customer} />
                <Row k="Codice" v={state.data.id} mono />
                <Row k="Revisione corrente" v={`v${state.data.current_revision || "—"} (${state.data.revisions_count || 0} totali)`} />
                <Row k="Stato" v={state.data.status} />
                <Row k="Creato" v={(state.data.created_at || "").slice(0, 10)} />
                <Row k="Ultimo aggiornamento" v={(state.data.updated_at || "").slice(0, 10)} />
                {state.data.signed_by?.length > 0 && <Row k="Firmato da" v={state.data.signed_by.map((r) => r.replace(/_/g, " ")).join(", ")} />}
              </div>
              <div className="pt-4 border-t border-border text-xs text-muted-foreground flex items-center gap-2">
                <FileText className="w-3.5 h-3.5" />
                Questa verifica conferma l'esistenza del documento e la sua revisione al momento della scansione del QR.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function Row({ k, v, mono }) {
  return (
    <div className="flex items-baseline gap-4">
      <div className="text-xs uppercase tracking-widest text-muted-foreground w-40 shrink-0">{k}</div>
      <div className={mono ? "font-mono text-xs" : ""}>{v || "—"}</div>
    </div>
  );
}
